import {EffectCallback, useEffect} from "react"

export const useEffectOnMount = (effect: EffectCallback): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, [])
}
